import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function outcomes() {
  return (
    <section className="outcome p-100 text_color">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              What were <span style={{ color: "#5A67FF" }}>the results?</span> 
            </h2>
            <p>
              The app ticked all the clients’ checkboxes and they were really
              happy with it. It also offers a smooth and hassle-free dating
              experience that our users seem to love.
            </p>
            <div className="outcome_img">
              <StaticImage
                src="../../../images/case-studies/moodbe/results.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1330}
                height={815}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default outcomes;
